import { makeStyles, tokens } from '@fluentui/react-components';

const flexColumn = {
  width: '100%',
  display: 'flex',
};

export const useDashboardStyles = makeStyles({
  banner: {
    ...flexColumn,
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXXL,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalXXL,
  },
  container: {
    ...flexColumn,
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
});
